import { Skeleton } from '@/_components/ui/skeleton'

import { getApplicationColumns } from '../_columns/application-table-columns'
import { LoadingDataTable } from '../_components/loading-data-table'
import { Container } from '../_components/ui/container'
import { Header, HeaderLeft, HeaderRight } from '../_components/ui/header'

export default function Loading() {
  return (
    <Container className="px-14 py-10 gap-6">
      <Header>
        <HeaderLeft>
          <Skeleton className="h-[20px] w-[300px] rounded-full" />
        </HeaderLeft>
        <HeaderRight>
          <Skeleton className="h-[20px] w-[200px] rounded-full" />
        </HeaderRight>
      </Header>
      <LoadingDataTable
        columns={getApplicationColumns({ showFacility: true, userType: 'staff' })}
      />
    </Container>
  )
}
